// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-padding {
  box-sizing: border-box;
  padding: 5px;
  margin: 16px 16px 4px 16px;
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
}

.no-rewards-container {
  border: 2px solid var(--ion-color-secondary);
  cursor: pointer;
}
.no-rewards-container span {
  font-family: var(--font-primary);
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  color: #000000;
  margin-left: 2px;
}
@media screen and (max-width: 968px) {
  .no-rewards-container span {
    font-size: 13px;
  }
}
@media screen and (max-width: 568px) {
  .no-rewards-container span {
    font-size: 12px;
  }
}
.no-rewards-container img {
  width: 55px;
  object-fit: contain;
}

.rewards-connect-container {
  background: #EFF3E5;
  border: 2px solid #28BE10;
}
.rewards-connect-container span {
  font-family: var(--font-primary);
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  color: #000000;
  cursor: pointer;
}
.rewards-connect-container span span {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  text-decoration-line: underline;
  color: #0099FF;
  cursor: pointer;
}
.rewards-connect-container div {
  width: 30px;
  padding-top: 5px;
}
.rewards-connect-container div ion-icon {
  color: #1ABA00;
}
.rewards-connect-container img {
  width: 55px;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/app/components/rewards-card/rewards-card.component.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,YAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AACJ;;AAEA;EACI,4CAAA;EACA,eAAA;AACJ;AAAI;EACI,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAER;AAAQ;EATJ;IAUQ,eAAA;EAGV;AACF;AADQ;EAbJ;IAcQ,eAAA;EAIV;AACF;AADI;EACI,WAAA;EACA,mBAAA;AAGR;;AAEA;EACI,mBAAA;EACA,yBAAA;AACJ;AAEI;EACI,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAAR;AACQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;AACZ;AAGI;EACI,WAAA;EACA,gBAAA;AADR;AAGQ;EACI,cAAA;AADZ;AAKI;EACI,WAAA;EACA,mBAAA;AAHR","sourcesContent":[".container-padding {\n    box-sizing: border-box;\n    padding: 5px;\n    margin: 16px 16px 4px 16px;\n    border-radius: 20px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.no-rewards-container {\n    border: 2px solid var(--ion-color-secondary);\n    cursor: pointer;\n    span {\n        font-family: var(--font-primary);\n        font-style: normal;\n        font-weight: 600;\n        font-size: 15px;\n        line-height: 18px;\n        color: #000000;\n        margin-left: 2px;\n\n        @media screen and (max-width: 968px) {\n            font-size: 13px;\n        }\n\n        @media screen and (max-width: 568px) {\n            font-size: 12px;\n        }\n    }\n\n    img {\n        width: 55px;\n        object-fit: contain;\n    \n    }\n}\n\n.rewards-connect-container {\n    background: #EFF3E5;\n    border: 2px solid #28BE10;\n\n\n    span {\n        font-family: var(--font-primary);\n        font-style: normal;\n        font-weight: 600;\n        font-size: 15px;\n        line-height: 18px;\n        color: #000000;\n        cursor: pointer;\n        span {\n            font-weight: 500;\n            font-size: 12px;\n            line-height: 14px;\n            text-decoration-line: underline;\n            color: #0099FF;\n            cursor: pointer;\n        }\n    }\n\n    div {\n        width: 30px;\n        padding-top: 5px;\n        \n        ion-icon {\n            color: #1ABA00;\n        }\n\n    }\n    img {\n        width: 55px;\n        object-fit: contain;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
